export enum DataDimension {
    Queue = 'queue',
    SuperGroup = 'supergroup',
}
